export default __webpack_public_path__ + "static/media/zora-proposal-header-small.aafd0184.jpg";